import SecureLS from "secure-ls";

export const ls = new SecureLS({
  encodingType: "rc4",
  isCompression: false,
  encryptionSecret: "Zs%Ma??5Qn,!ZB#_nhM"
});


export const isJSON = (value) => {
  try { 
    JSON.parse(value); 
    
    return true; 
  } catch (e) { 
    return false; 
  }
}


export const paymentMethodDisplayMinSpendValue = (type) => {
  let min_spend = 0;
  if (type.includes('PAYMONGO')) min_spend = 100;
  else if (type === 'CC_XENDIT') min_spend = 20;
  else if (type.includes('XENDIT')) min_spend = 1;
  return min_spend;
};

export const paymentMethodDisplayMaxSpendValue = (type) => {
  if (type === "PAYMAYA_XENDIT" || type === "UNIONBANK_XENDIT") return 100000;
  return 50000;
};

export const paymentMethodDisplayLabel = (type) => {
  let display_text = "";
  if (type === "COD") display_text = "Cash on Delivery";
  else if (type.includes('CC')) display_text = "Local Debit/Credit Cards";
  else if (type.includes('GRAB_PAY')) display_text = "GrabPay";
  else if (type.includes('GCASH')) display_text = "GCash";
  else if (type.includes('PAYMAYA')) display_text = "Maya";
  else if (type.includes('SHOPEEPAY')) display_text = "ShopeePay";
  else if (type.includes('QRPH')) display_text = "QR Ph";
  else if (type.includes('UNIONBANK')) display_text = "UnionBank - Direct Debit"
  return display_text;
};

export const paymentMethodDisplayIcon = (type) => {
  let img = null;
  if (type === "COD") img = require('@/assets/images/ic-cod.svg');
  else if (type.includes('CC')) img = require('@/assets/images/credit-card-visa-master.png');
  else if (type.includes('GRAB_PAY')) img = require('@/assets/images/ic-grabpay.png');
  else if (type.includes('GCASH')) img = require('@/assets/images/ic-gcash.png');
  else if (type.includes('PAYMAYA')) img = require('@/assets/images/ic-maya.png');
  else if (type.includes('SHOPEEPAY')) img = require('@/assets/images/ic-shopeepay.png');
  else if (type.includes('QRPH')) img = require('@/assets/images/ic-qr-ph.png');
  else if (type.includes('UNIONBANK')) img = require('@/assets/images/ic-unionbank.png');
  return img;
};

export const hexToRgba = (hex, alpha) =>
  `rgba(${parseInt(hex.slice(1, 3), 16)}, ${parseInt(hex.slice(3, 5), 16)}, ${parseInt(
    hex.slice(5, 7),
    16
  )}, ${alpha})`;

export const thousandsSeparator = (value) => new Intl.NumberFormat('en-US').format(value);
